import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GlobalErrorHandler } from '@salesrun/ngx-logging/services/global.error-handler';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { LOGGING_OPTIONS, NEW_RELIC_CLIENT, ROLLBAR_CLIENT } from './logging.constants';
import { ILoggingOptions } from './models/ILoggingOptions';
import { newRelicFactory } from './providers/newRelicFactory';
import { rollbarFactory } from './providers/rollbarFactory';
import { ErrorInterceptor } from './services/error.interceptor';
import { LoggerService } from './services/logger.service';



@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        MatSnackBarModule,
        MatButtonModule,
    ],
    declarations: [
        ErrorDialogComponent,
    ],
})
export class LoggingModule {

    static forRoot(options: ILoggingOptions): ModuleWithProviders<LoggingModule> {
        return {
            ngModule: LoggingModule,
            providers: [
                LoggerService,
                { provide: LOGGING_OPTIONS, useValue: options },
                { provide: ROLLBAR_CLIENT, useFactory: rollbarFactory, deps: [LOGGING_OPTIONS] },
                { provide: NEW_RELIC_CLIENT, useFactory: newRelicFactory, deps: [LOGGING_OPTIONS] },
                { provide: ErrorHandler, useExisting: GlobalErrorHandler },
                { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
            ],
        };
    }

}
